var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-resize-observer", { on: { resize: _vm.onResize } }, [
    _c("div", { attrs: { "data-component": "layout-switcher-menu" } }, [
      _c(
        "div",
        { ref: "nav", staticClass: "menu-navigation" },
        [
          _vm._l(_vm.visibleItems, function (item) {
            return _c("div", { key: item.key, staticClass: "menu-item" }, [
              _c(
                "a",
                {
                  staticClass: "menu-item-link",
                  class: { "is-active": item.key === _vm.activeWorkspace },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onLinkClick(item.key)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t(item.name)) + "\n        "
                  ),
                ]
              ),
            ])
          }),
          _vm._v(" "),
          _c("or-icon-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMenuButtonVisible,
                expression: "isMenuButtonVisible",
              },
            ],
            ref: "buttonRef",
            attrs: { "data-menu-trigger": "", icon: "more_horiz" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                _vm.isMenuOpen = true
              },
            },
          }),
          _vm._v(" "),
          _vm.isMenuButtonVisible
            ? _c(
                "or-menu",
                {
                  ref: "menu",
                  attrs: {
                    trigger: _vm.buttonRoot,
                    "is-open": _vm.isMenuOpen,
                    "data-menu": "",
                  },
                  on: {
                    open: function ($event) {
                      _vm.isMenuOpen = true
                    },
                    close: function ($event) {
                      _vm.isMenuOpen = false
                    },
                  },
                },
                _vm._l(_vm.menuItems, function (ref) {
                  var key = ref.key
                  var name = ref.name
                  return _c(
                    "or-menu-item",
                    {
                      key: key,
                      attrs: {
                        selected: key === _vm.activeWorkspace,
                        "data-menu-item": key,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onLinkClick(key)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(name) + "\n        ")]
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }